<section class="u-maxY u-flex SsoPayment u-column">
  @if (config.sso_text || config.sso_image_url) {
    <img
      class="SsoPayment__Img"
      [attr.alt]="config.sso_modal_title"
      [src]="
        config.sso_image_url ||
        'https://d32ul9oyxvd2n5.cloudfront.net/illustrations/empty-2.svg'
      "
      [title]="config.sso_modal_title"
      data-test-id="ssoPaymentImg"
    />
  }
  <div class="u-maxY u-flex u-column u-justifyBetween">
    @if (config.sso_text) {
      <p
        data-test-id="sso-payment__paragraph"
        class="SsoPayment__Paragraph"
        [innerHtml]="config.sso_text"
      ></p>
    }
    <ds-link
      [linkConfig]="config | linkConfig"
      [externalSiteModalConfig]="config | externalSiteModalConfig"
    ></ds-link>
  </div>
</section>
